import { z } from "zod";
import { Entity } from "../../common/entity";
import { DbCreateInputOmit, DbUpdate } from "../../helpers";
import { OmitStrict } from "../../utils";

export const ForgeProjectRoom = Entity.extend({
  projectId: z.string(),
  liveblocksId: z.string(),
});

export type ForgeProjectRoom = z.infer<typeof ForgeProjectRoom>;

export type CreateForgeProjecRoom = DbCreateInputOmit<ForgeProjectRoom>;
export type UpdateForgeProjecRoom = OmitStrict<DbUpdate<ForgeProjectRoom>, "projectId" | "liveblocksId">;
